declare namespace $ {

	export class $mol_icon_view_grid extends $mol_icon {
		path( ): string
	}
	
}

//# sourceMappingURL=grid.view.tree.d.ts.map